class CartNotification extends HTMLElement {
    constructor() {
        super();

        this.notification = document.getElementById('cart-notification');
        this.onBodyClick = this.handleBodyClick.bind(this);
        this.onFocusin = this.handleFocusin.bind(this);
        this.onKeyDown = this.handleKeyDown.bind(this);
        this.onResize = this.getLastFocusableElements.bind(this);
        this.shippingThreshold = this.notification.getAttribute('data-shipping-threshold');
        this.mainCloseButton = this.querySelector('.cart-notification__close');

        this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
            closeButton.addEventListener('click', this.close.bind(this))
        );
        this.querySelector('.cart-preview-bg').addEventListener('click', this.close.bind(this));
        this.addEventListener('keydown', this.onKeyDown);
    }

    connectedCallback() {
        window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
    }

    open() {
        this.classList.remove('hide');
        this.notification.classList.add('animate', 'active');
        this.opener = document.activeElement;
        this.notification.focus();

        document.body.addEventListener('click', this.onBodyClick);
        const cartDrawerOpenedCustomEvent = new CustomEvent('cartDrawerOpened');
        document.dispatchEvent(cartDrawerOpenedCustomEvent);
        if (window.updateSlider) {
            const algoliaCartUpsellsSlide = window.updateSlider['data-algolia-cart-upsells'];
            if (algoliaCartUpsellsSlide) algoliaCartUpsellsSlide.update();
        }

        document.addEventListener('focusin', this.onFocusin);
    }

    close() {
        this.classList.add('hide');
        this.notification.classList.remove('active');

        document.body.removeEventListener('click', this.onBodyClick);
        document.removeEventListener('focusin', this.onFocusin);
        this.opener.focus();
    }

    handleFocusin() {
        if (this.contains(document.activeElement)) {
            this.recentlyFocusedElement = document.activeElement;
        } else {
            if (
                this.lastFocusableElement &&
                this.recentlyFocusedElement == this.lastFocusableElement
            )
                this.mainCloseButton.focus();
            else this.lastFocusableElement.focus();
        }
    }

    getLastFocusableElements() {
        this.upsellBullets = this.querySelectorAll('.slider__bullet.glide__bullet');
        this.upsellArrows = this.querySelectorAll('.glide__arrow');
        this.upsellArrows.forEach((arrow) => {
            const computedStyle = window.getComputedStyle(arrow);
            if (computedStyle.display == 'none' || computedStyle.visibility == 'hidden') {
                return;
            }
            this.lastFocusableElement = arrow;
        });
        if (!this.upsellBullets[0] || this.upsellBullets[0].offsetParent === null) return;
        this.lastFocusableElement = this.upsellBullets[this.upsellBullets.length - 1];
    }

    handleKeyDown(event) {
        if (!this.lastFocusableElement) {
            this.getLastFocusableElements();
        }
        switch (event.keyCode) {
            case 9: {
                if (event.shiftKey && document.activeElement == this.mainCloseButton) {
                    event.preventDefault();
                    this.lastFocusableElement.focus();
                } else if (
                    !event.shiftKey &&
                    this.mainCloseButton &&
                    document.activeElement == this.lastFocusableElement
                ) {
                    event.preventDefault();
                    this.mainCloseButton.focus();
                }

                break;
            }
            case 27:
                this.close();
                break;
            default:
                break;
        }
    }

    showBundleCartNotification(parsedState) {
        const cartNotifProductImage = document.querySelector('.cart-notification-product__image');
        if (cartNotifProductImage) cartNotifProductImage.setAttribute('src', parsedState.image);

        const cartNotifProductName = document.querySelector('.cart-notification-product__name');
        if (cartNotifProductName) cartNotifProductName.innerText = parsedState.title;

        const cartNotifProductOption = document.querySelector('.cart-notification-product__option');
        if (cartNotifProductOption) cartNotifProductOption.style.display = 'none';
    }

    async fetchCartData() {
        try {
            const response = await fetch('/cart.js', {cache: 'no-store'});
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Failed to fetch cart data:', error);
            return null;
        }
    }

    calculateProductQuantities(cartData) {
        const productQuantities = {};
        cartData.items.forEach((item) => {
            if (!productQuantities[item.variant_id]) {
                productQuantities[item.variant_id] = 0;
            }
            let quantity = item.quantity;
            if (item.properties && item.properties['_two_pack_id']) {
                quantity = item.quantity / 2;
            }
            productQuantities[item.variant_id] += quantity;
            if (item.quantity > 3) productQuantities.hasExceedingLineItemQuantity = true;
        });
        return productQuantities;
    }

    async renderMaxQtyMessage(parsedState) {
        const cartData = await this.fetchCartData();
        if (!cartData) {
            return;
        }
        const productQuantities = this.calculateProductQuantities(cartData);
        if (!productQuantities[parsedState.variant_id]) {
            productQuantities[parsedState.variant_id] = 0;
        }
        productQuantities[parsedState.variant_id] += parsedState.quantity;
        const cartErrorEl = document.querySelector('[data-cart-error]');
        if (cartErrorEl) cartErrorEl.classList.add('is-hidden');

        const cartMaxQtyEl = document.querySelector('[data-max-qty-message]');
        if (cartMaxQtyEl) cartMaxQtyEl.classList.add('is-hidden');

        if (productQuantities[parsedState.variant_id] == 3) {
            const availableQty =
                parsedState.status == 422
                    ? 0
                    : 3 - (productQuantities[parsedState.variant_id] - parsedState.quantity);

            document.querySelector('[data-max-qty-message]').classList.remove('is-hidden');

            const stickyQtySelector = document.querySelector('.sticky-quantity__input');
            const qtySelector = document.querySelector('[name="quantity"]');
            if (qtySelector) {
                qtySelector.value = availableQty;
                qtySelector.max = availableQty;

                const plusBtn = qtySelector.parentElement.querySelector('[name="plus"]');
                if (plusBtn) plusBtn.setAttribute('disabled', true);
            }
            if (stickyQtySelector) {
                stickyQtySelector.value = availableQty;
                stickyQtySelector.max = availableQty;
                const stickyPlusBtn =
                    stickyQtySelector.parentElement.querySelector('[name="plus"]');
                if (stickyPlusBtn) stickyPlusBtn.setAttribute('disabled', true);
            }
        } else if (
            productQuantities[parsedState.variant_id] > 3 ||
            productQuantities.hasExceedingLineItemQuantity
        ) {
            const cartErrorEl = document.querySelector('[data-cart-error]');
            if (cartErrorEl) {
                cartErrorEl.classList.remove('is-hidden');
                cartErrorEl.innerText =
                    'We have noticed that some items in your cart exceed the maximum quantity allowed. Please update the quantity to proceed.';
            }
        }

        const stickyATCButton = document.querySelector('.sticky-addtocart');
        const mainACTButton = document.querySelector('#pdp-product-form [type="submit"]');
        if (mainACTButton) {
            mainACTButton.setAttribute('disabled', true);
        }
        if (stickyATCButton) {
            stickyATCButton.setAttribute('disabled', true);
        }
        return;
    }

    async renderContents(parsedState, bundleParentData) {
        this.productId = parsedState.id;
        if (
            parsedState?.status === 422 &&
            parsedState?.message === 'Order limit is 3 of the same product'
        ) {
            await this.renderMaxQtyMessage(parsedState);
            return;
        }
        this.getSectionsToRender().forEach((section) => {
            document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.id],
                section.selector
            );
            if (section.id != 'cart-preview-section') return;
            document.querySelector('cart-preview')?.init();
        });

        if (bundleParentData) {
            this.showBundleCartNotification(bundleParentData);
        }

        this.open();
    }

    getSectionsToRender() {
        return [
            {
                id: 'cart-notification-product',
                selector: `#cart-notification-product-${this.productId}`
            },
            {
                id: 'cart-notification-button'
            },
            {
                id: 'cart-icon-bubble'
            },
            {
                id: 'cart-icon-bubble-desktop'
            },
            {
                id: 'cart-preview-section'
            }
        ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    handleBodyClick(evt) {
        const target = evt.target;
        if (target !== this.notification && !target.closest('cart-notification')) {
            const disclosure = target.closest('details-disclosure');
            this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
            this.close();
        }
    }

    // This is called by updateCartNotification in product-form.js
    // We don't have the cart total price here, so hooking into the response in product-form.js allows us to use an existing request to get the total
    updateShippingThreshold(total) {
        const cartPrice = total / 100;
        const offsetContainer = document.getElementById('cart-notification__free-shipping');
        const offsetValueContainer = document.getElementById('cart-notification-shipping-offset');
        const rechargeSubRadio = document.querySelector('input.rc_widget__option__input--subsave');
        const cartNotificationBox = document.querySelector('#cart-notification');

        if (!offsetContainer || !this.shippingThreshold || !offsetValueContainer) return;

        const shippingAchievedMessaging = offsetContainer.querySelector(
            '.cart-notification__shipping-achieved'
        );
        const shippingOffsetMessaging = offsetContainer.querySelector(
            '.cart-notification__shipping-offset'
        );
        if (
            cartPrice >= this.shippingThreshold ||
            (rechargeSubRadio && rechargeSubRadio.checked) ||
            cartNotificationBox.classList.contains('free-shipping-qualified')
        ) {
            if (shippingAchievedMessaging) shippingAchievedMessaging.classList.remove('hidden');
            if (shippingOffsetMessaging) shippingOffsetMessaging.classList.add('hidden');
        } else {
            if (shippingAchievedMessaging) shippingAchievedMessaging.classList.add('hidden');
            if (shippingOffsetMessaging) shippingOffsetMessaging.classList.remove('hidden');
            const offsetValue = (this.shippingThreshold - cartPrice).toFixed(2);
            offsetValueContainer.textContent = `$${offsetValue}`;
        }
    }

    // This is called by updateCartNotification in product-form.js
    // We don't have the cart total price here, so hooking into the response in product-form.js allows us to use an existing request to get the total
    updateFreeGift(total, hasGift) {
        if (!total || typeof hasGift === typeof undefined) return;
        const cartPrice = total / 100;
        const messaging = document.getElementById('free-gift-messaging');
        const product = document.getElementById('free-gift-product');
        const threshold = this.notification.getAttribute('data-gift-threshold');
        if (!messaging || !product || !threshold) return;
        const remaining = messaging.querySelector('[data-remaining]');
        const achieved = messaging.querySelector('[data-achieved');
        if (!remaining || !achieved) return;
        messaging.classList.remove('hidden');
        if (cartPrice >= threshold) {
            remaining.classList.add('hidden');
            achieved.classList.remove('hidden');
            if (!hasGift) {
                product.classList.remove('hidden');
            } else {
                product.classList.add('hidden');
            }
        } else {
            const offsetValue = (threshold - cartPrice).toFixed(2);
            const valueMarkup = remaining.querySelector('strong');
            if (valueMarkup) valueMarkup.textContent = `$${offsetValue}`;
            remaining.classList.remove('hidden');
            achieved.classList.add('hidden');
            product.classList.add('hidden');
        }
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define('cart-notification', CartNotification);

class CartPreview extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.init();
        window.addEventListener('resize', this.onResizeHandler);
        this.cartUpdateObserver();
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this.onResizeHandler);
    }

    cartUpdateObserver() {
        const observer = new MutationObserver((mutationsList) => {
            for (let mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    this.init();
                    observer.disconnect();
                }
            }
        });
        observer.observe(this, {childList: true});
    }

    init() {
        this.cartPreview = this.querySelector('[data-cart-preview]');
        this.close();

        if (!this.cartPreview) throw new Error('Could not find cart preview wrappers.');

        this.closeTriggers = this.querySelectorAll('.cart-preview__close');
        this.mainCloseButton = this.querySelector(
            'button.cart-preview__close:not(.continue-shopping)'
        );
        this.openTriggers = document.querySelectorAll('[data-toggle-cart-preview]');

        this.onCloseHandler = this.close.bind(this);
        this.onOpenHandler = this.open.bind(this);
        this.onFocusinHandler = this.handleFocusin.bind(this);
        this.onKeyDownHandler = this.handleKeyDown.bind(this);
        this.onResizeHandler = this.resize.bind(this);
        this.closeTriggers.forEach((trigger) => {
            trigger.addEventListener('click', this.onCloseHandler);
        });

        this.openTriggers.forEach((trigger) => {
            trigger.addEventListener('click', this.onOpenHandler);
        });

        this.addEventListener('keydown', this.onKeyDownHandler);
    }

    resize() {
        this.getLastFocusableElements();
    }
    open() {
        this.opener = document.activeElement;
        this.classList.remove('hide');
        this.cartPreview.classList.add('is-active');
        this.getLastFocusableElements();
        window.addEventListener('focusin', this.onFocusinHandler);
        this.mainCloseButton.focus();
    }

    close() {
        this.classList.add('hide');
        this.cartPreview.classList.remove('is-active');

        window.removeEventListener('focusin', this.onFocusinHandler);
        if (this.opener) this.opener.focus();
    }

    handleFocusin() {
        if (this.contains(document.activeElement)) {
            this.recentlyFocusedElement = document.activeElement;
        } else if (this.lastFocusableElement) {
            if (this.recentlyFocusedElement == this.lastFocusableElement)
                this.mainCloseButton.focus();
            else this.lastFocusableElement.focus();
        }
    }

    getLastFocusableElements() {
        this.upsellBullets = this.querySelectorAll('.slider__bullet.glide__bullet');
        this.upsellArrows = this.querySelectorAll('.glide__arrow');
        this.upsellArrows.forEach((arrow) => {
            const computedStyle = window.getComputedStyle(arrow);
            if (computedStyle.display == 'none' || computedStyle.visibility == 'hidden') {
                return;
            }
            this.lastFocusableElement = arrow;
        });
        if (!this.upsellBullets[0] || this.upsellBullets[0].offsetParent === null) return;
        this.lastFocusableElement = this.upsellBullets[this.upsellBullets.length - 1];
    }

    handleKeyDown(event) {
        if (!this.lastFocusableElement) {
            this.getLastFocusableElements();
        }
        switch (event.keyCode) {
            case 9: {
                if (event.shiftKey && document.activeElement == this.mainCloseButton) {
                    event.preventDefault();
                    this.lastFocusableElement.focus();
                } else if (
                    !event.shiftKey &&
                    this.mainCloseButton &&
                    document.activeElement == this.lastFocusableElement
                ) {
                    event.preventDefault();
                    this.mainCloseButton.focus();
                }

                break;
            }
            case 27:
                this.close();
                break;
            default:
                break;
        }
    }
}

customElements.define('cart-preview', CartPreview);
